module.exports = __webpack_public_path__ + "static/media/luma-muted.f6d59b38.svg";